import loadable from "@loadable/component";

export const ServiceLogListPage = loadable(() => import("./service-logs/list"));

export const ServiceLogDetailPage = loadable(
  () => import("./service-logs/show")
);

export const ServiceRecords = loadable(() => import("./service-records"));

export const PickupServiceDetail = loadable(
  () => import("./pickup-service/detail"),
  { resolveComponent: ({ PickupServiceDetail }) => PickupServiceDetail }
);

export const CourierServiceDetail = loadable(
  () => import("./courier-service/detail"),
  { resolveComponent: ({ CourierServiceDetail }) => CourierServiceDetail }
);

export const StorageServiceDetail = loadable(
  () => import("./storage-service/detail"),
  { resolveComponent: ({ StorageServiceDetail }) => StorageServiceDetail }
);

export const RentServiceDetail = loadable(
  () => import("./rent-service/detail"),
  { resolveComponent: ({ RentServiceDetail }) => RentServiceDetail }
);

export const DebugRecords = loadable(() => import("./debug-records"), {
  resolveComponent: ({ DebugRecords }) => DebugRecords,
});

export const DebugRecordDetail = loadable(
  () => import("./debug-records/detail"),
  { resolveComponent: ({ DebugRecordDetail }) => DebugRecordDetail }
);

export const EntranceRecordDetail = loadable(
  () => import("./entrance-records/detail"),
  { resolveComponent: ({ EntranceRecordDetail }) => EntranceRecordDetail }
);
